import './App.css';
import React from 'react'
import Login from './components/auth/Login';
import Yield from './components/pages/Yield';
import DemoPlot from './components/pages/DemoPlot';
import Breadcrumb from './components/pages/Breadcrumb';
import Dashboard from './components/pages/Dashboard';
import Pesticide from './components/pages/Pesticide';
import Irrigation from './components/pages/Irrigation';
import Fertilizer from './components/pages/Fertilizer';
import ProtectedRoute from './components/layout/ProtectedRoute';
import {  BrowserRouter as Router,  Routes,  Route, Navigate} from 'react-router-dom';
import Profile from './components/pages/Profile';       
import Milldashboard from './components/millDashboard/Milldashboard';
import MillList from './components/pages/MillList';

export const UserContext = React.createContext();

function App() {
  var isLoggedIn = localStorage.getItem("token");
  return (
    <UserContext.Provider value={"Read"}>
       <Router>
           
           <Routes>
             <Route exact  path="/" element={  <Navigate replace to="/login" />}/> 
             <Route exact  path="/login" element={<Login />}/>
             <Route exact  path='/farmer_profile' element={<ProtectedRoute Component={Profile}/>}/>
             <Route exact  path="/overview" element={<ProtectedRoute Component={Dashboard} />}/>
             <Route exact  path="/irrigation" element={<ProtectedRoute Component={Irrigation} />} />
             <Route exact  path="/input" element={<ProtectedRoute Component={Fertilizer} />} />
             <Route exact  path="/yield" element={<ProtectedRoute Component={Yield} />} />
             <Route exact  path="/demo-plot" element={<ProtectedRoute Component={DemoPlot} />} />
             <Route exact  path="/mill-dashboard" element={<ProtectedRoute Component={Milldashboard} />} />
             <Route exact  path="/mill_list" element={<ProtectedRoute Component={MillList} />} />
           </Routes>
     
  
</Router>
    </UserContext.Provider>
   
  );
}

export default App;
